
import { Injectable } from '@angular/core';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { MailItemType } from 'app/shared/models/admin/MailItemType';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class RemarkService {


  private static readonly endpoint = 'Remarks';
  constructor(private http: HttpClientService) { }

  list(body: Object) {
    return this.http.post(body,`${RemarkService.endpoint}/GetAll`, undefined, services.orderService)
  }

  create(model: Object): Observable<MailItemType> {
    return this.http.post(model, `${RemarkService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: object): Observable<any> {
    return this.http.put(model, `${RemarkService.endpoint}/Update`, services.orderService);
  }

  delete(id: number) {
    return this.http.delete<boolean>(`${RemarkService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
}
